const HumanizeNumber = ( {
  children
} ) => {
  if ( typeof children !== 'number' )
    return null

  const n = children.toFixed( 2 )

  return <>{ n }</>
}

export default HumanizeNumber
